import { useLayer } from "./useLayer";
import { useContent } from "./useContent";
import { useMemo } from "react";

export function useLayerCitations() {
  const { citations: allCitations } = useContent();

  const layer = useLayer();

  const citations = useMemo(() => {
    switch (layer.type) {
      case "content":
        return allCitations.content;
      case "excursion":
        if (!layer.slug || !allCitations.excursions[layer.slug ?? ""])
          return [];
        return allCitations.excursions[layer.slug] ?? [];
      default:
        return [];
    }
  }, [allCitations, layer]);

  return citations ?? [];
}
